document.addEventListener('click', (e) => {
  const btn = e.target.closest('.tab-btn');
  if (!btn) return;

  const tab = btn.dataset.tab;
  const container = btn.closest('.tab-menu');
  if (!container || !tab) return;

  const targetPanel = container.querySelector(`.tab-panel[data-panel="${tab}"]`);
  if (!targetPanel) return;

  container.querySelectorAll('.tab-btn').forEach((b) => {
    b.classList.remove('is-active');
  });

  container.querySelectorAll('.tab-panel').forEach((p) => {
    p.classList.remove('is-active');
  });

  btn.classList.add('is-active');
  targetPanel.classList.add('is-active');
});